




















import { Component, Vue, Prop, Inject } from "vue-property-decorator";
@Component({
  components: {},
})
export default class TitleHeader extends Vue {
  @Inject() public readonly switchOver;
  @Prop({ default: "", type: String }) private titleName;
  @Prop({ default: false, type: Boolean }) private retreat;
  @Prop({ default: true, type: Boolean }) private changeStatus;
  @Prop({ default: false, type: Boolean }) private close;
  public closeHome(val) {
    const status = this.$store.state.user.info.age_status;
    if (status === 0) {
      return this.$toast("请先进行实名认证");
    } else if (status === 3) {
      return this.$toast("未成年暂无开放游戏权限");
    }
    this.switchOver(val);
  }
  public routeGo() {
    this.$fn.delUserInfo();
    this.$router.push({path: '/login'})
  }
}
